import { Reducer } from 'redux'
import { CombinedFundingSummaryResponse } from './fundingApi'

export interface FundingSummaryState {
  /** Combined funding summary (all programs): stat-card totals + ToDo lists. */
  fundingSummary: CombinedFundingSummaryResponse | null
}

export enum FundingSummaryActionTypes {
  SET_FUNDING_SUMMARY = 'FUNDING_SUMMARY_SET',
}

type FundingSummaryAction = {
  type: FundingSummaryActionTypes.SET_FUNDING_SUMMARY
  payload: CombinedFundingSummaryResponse | null
}

export const initialState: FundingSummaryState = {
  fundingSummary: null,
}

export const reducer: Reducer<FundingSummaryState, FundingSummaryAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case FundingSummaryActionTypes.SET_FUNDING_SUMMARY:
      return { ...state, fundingSummary: action.payload }
    default:
      return state
  }
}
